import React from "react";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";

function AboutProject({ formData, handleEditorChange }) {
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">About Project</legend>

      <div>
        <label className="block text-gray-700 font-medium mb-2">Project Description</label>
        <ReactQuill
          value={formData.aboutProject}
          onChange={handleEditorChange}
          className="bg-white overflow-y-scroll"
          placeholder="Write about the project details, features, and highlights..."
          style={{ height: "300px" }}  // <-- Default height set
        />
      </div>
    </fieldset>
  );
}

export default AboutProject;
